module.exports = __webpack_public_path__ + "img/17.1e345b47.gif";